import { render } from "./resendEmail.vue?vue&type=template&id=010f7530"
import script from "./resendEmail.vue?vue&type=script&lang=js"
export * from "./resendEmail.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__